import Vue from 'vue'
import Vuex from 'vuex'
import store from './../store/index'
import { getToken } from '@/util/auth'
import timeJs from '@/util/timeFormat'
import searchJs from '@/util/search'
const cookieUser = getToken()
/**
 * 任务查询条件通用方法调用：适用于任务精确查找
 * @param {*} para 任务搜索条件
 * @param {*} isType 0:文本框内容精确查找 1：模板直接查询 2.创建模板
 */
function searchTask(para, isType) {
  let alone = para.Alone
  alone.createtimeRange = timeDisposal(
    alone.createtimeRange,
    alone.createtimeRadio,
    alone.createtimeInput,
    alone.createTimeDynamic
  )
  if(alone.createtimeRange){
    if (alone.createtimeRange.length === 2) {
      para.CreateTime1 = alone.createtimeRange[0]
      para.CreateTime2 = alone.createtimeRange[1]
    }
  }
  //时间处理
  alone.receiveTimeRange = timeDisposal(
    alone.receiveTimeRange,
    alone.receiveTimeRadio,
    alone.receiveTimeInput,
    alone.receiveTimeDynamic
  )
  if(alone.receiveTimeRange){
    if (alone.receiveTimeRange.length === 2) {
      para.AcceptTime1 = alone.receiveTimeRange[0]
      para.AcceptTime2 = alone.receiveTimeRange[1]
    }
  }
  alone.circulationtimeRange = timeDisposal(
    alone.circulationtimeRange,
    alone.circulationtimeRadio,
    alone.circulationtimeInput,
    alone.circulationtimeDynamic
  )
  if(alone.circulationtimeRange){
    if (alone.circulationtimeRange.length === 2) {
      para.TransferTime1 = alone.circulationtimeRange[0]
      para.TransferTime1 = alone.circulationtimeRange[1]
    }
  }
  alone.audittimeRange = timeDisposal(
    alone.audittimeRange,
    alone.audittimeRadio,
    alone.audittimeInput,
    alone.auditTimeDynamic
  )
  if(alone.audittimeRange){
    if (alone.audittimeRange.length === 2) {
      para.AuditTime1 = alone.audittimeRange[0]
      para.AuditTime2 = alone.audittimeRange[1]
    }
  }
  alone.completetimeRange = timeDisposal(
    alone.completetimeRange,
    alone.completetimeRadio,
    alone.completetimeInput,
    alone.completeTimeDynamic
  )
  if(alone.completetimeRange){
    if (alone.completetimeRange.length === 2) {
      para.CompleteTime1 = alone.completetimeRange[0]
      para.CompleteTime2 = alone.completetimeRange[1]
    }
  }
  alone.closetimeRange = timeDisposal(
    alone.closetimeRange,
    alone.closetimeRadio,
    alone.closetimeInput,
    alone.closeTimeDynamic
  )
  if(alone.closetimeRange){
    if (alone.closetimeRange.length === 2) {
      para.CloseTime1 = alone.closetimeRange[0]
      para.CloseTime2 = alone.closetimeRange[1]
    }
  }
  if (alone.overduetimeRange) {
    if (alone.overduetimeRadio >= 4) {
      alone.overduetimeRange = timeDisposal(
        alone.overduetimeRange,
        alone.overduetimeRadio,
        alone.overduetimeInput2,
        alone.overduetimeDynamic2
      )
    } else {
      alone.overduetimeRange = timeDisposal(
        alone.overduetimeRange,
        alone.overduetimeRadio,
        alone.overduetimeInput,
        alone.overduetimeDynamic
      )
    }

    if (alone.overduetimeRange.length === 2) {
      para.OutDateTime1 = alone.overduetimeRange[0]
      para.OutDateTime2 = alone.overduetimeRange[1]
    }
  }
  // if (!alone.TaskClass) {
  //   alone.TaskClass = 'fuwu'
  // }
  // console.log('执行人本人', alone.ExcuteMe);
  //时间处理结束
  //人员时本人
  if (alone.ExcuteMe && isType !== 2) {
    //执行人是本人
    if (para.ExcuteUserIds) {
      if (para.ExcuteUserIds.split(',').indexOf(cookieUser.userId) == -1) {
        para.ExcuteUserIds += ',' + cookieUser.userId
        console.log(para.ExcuteUserIds)
      }
    } else {
      para.ExcuteUserIds = cookieUser.userId
    }
  }
  if (alone.CreateMe && isType !== 2) {
    //创建人是本人
    if (para.CreateUserIds) {
      if (para.CreateUserIds.split(',').indexOf(cookieUser.userId) == -1) {
        para.CreateUserIds += ',' + cookieUser.userId
      }
    } else {
      para.CreateUserIds = cookieUser.userId
    }
  }
  if (alone.LinkManMe && isType !== 2) {
    //联系人是本人
    if (para.LinkManIds) {
      if (para.LinkManIds.split(',').indexOf(cookieUser.ContactID) == -1) {
        para.LinkManIds += ',' + cookieUser.ContactID
      }
    } else {
      para.LinkManIds = cookieUser.ContactID
    }
  }
  if (alone.TaskMemeberMe && isType !== 2) {
    //干系人是本人
    if (para.TaskMemeberIds) {
      if (para.TaskMemeberIds.indexOf(cookieUser.userId) == -1) {
        para.TaskMemeberIds += ',' + cookieUser.userId
      }
    } else {
      para.TaskMemeberIds = cookieUser.userId
    }
  }
  if (alone.ConvertMe && isType !== 2) {
    //干系人是本人
    if (para.ConvertUserIds) {
      if (para.ConvertUserIds.indexOf(cookieUser.userId) == -1) {
        para.ConvertUserIds += ',' + cookieUser.userId
      }
    } else {
      para.ConvertUserIds = cookieUser.userId
    }
  }
  // //人员时本人结束
  // if (alone.meCompanyDept && isType !== 2) { //我管理的组织机构
  //   para.TaskRightId = cookieUser.companyDeptIds;//store.state.task.companyDeptIds; //
  // }
  if (alone.typeView === 1) {
    if (alone.meCompanyDept) {
      //我管理的组织机构
      para.TypeIndex = -3
    } else {
      para.TypeIndex = -2
    }
  }
  // } else {
  //   console.log('para.TypeIndex3', para.TypeIndex)
  //   para.TypeIndex = -1
  // }

  // console.log('组织机构人员', alone.companyDeptCheckList)
  if(alone.companyDeptCheckList){
    para.RoleType = alone.companyDeptCheckList.join(',')
  }
  //任务状态
  if (para.state.length == 0) {
    para.ExcuteState = ''
  } else {
    para.ExcuteState = para.state.join()
  }
  //任务标签
  console.log('TagIds',alone.TagIds);
  if (alone.TagIds) {
    para.TagIds = alone.TagIds.join()
  }
  if (isType === 0 || isType === 2) {
    //任务报修来源

    if (Array.prototype.isPrototypeOf(para.CreateSource)) {
      para.CreateSource = para.CreateSource.join()
    }
    //任务等级
    if (Array.prototype.isPrototypeOf(para.TaskDegree)) {
      para.TaskDegree = para.TaskDegree.join()
    }
    //任务类型
    if (Array.prototype.isPrototypeOf(para.TaskType)) {
      para.TaskType = para.TaskType.join()
    }
    if (Array.prototype.isPrototypeOf(para.ServerCenterIds)) {
      para.ServerCenterIds = alone.ServerCenterIds.join()
    }
  }
  if (alone.meServiceCenter) {
    //我管理的服务台
    para.ServerCenterIds = cookieUser.ReceptionIds
  }

  if (alone.serviceDesk) {
    let AllServerCenterval = localStorage.getItem('AllServerCenter');
    if (AllServerCenterval) {
      let AllServerCenter = JSON.parse(AllServerCenterval);
      console.log('服务台', AllServerCenter)
      //待完成
      if (alone.serviceDesk == '1') {
        AllServerCenter = AllServerCenter.filter(item => item.ONLINE == true)
        if (AllServerCenter.length > 0) {
          let AllServerCenterArr = AllServerCenter.map(function (item) {
            return "3_" + item.ID;
          });
          if (para.TaskRightId) {
            AllServerCenterArr.forEach(v => {
              if (para.TaskRightId.split(',').indexOf(v) == -1) {
                para.TaskRightId += ',' + v
              }
            });
          } else {
            para.TaskRightId = AllServerCenterArr.join()
          }
        }

      } else if (alone.serviceDesk == '2') {
        if (AllServerCenter.length > 0) {
          let AllServerCenterArr = AllServerCenter.map(function (item) {
            return "3_" + item.ID;
          });
          if (para.TaskRightId) {
            AllServerCenterArr.forEach(v => {
              if (para.TaskRightId.split(',').indexOf(v) == -1) {
                para.TaskRightId += ',' + v
              }
            });
          } else {
            para.TaskRightId = AllServerCenterArr.join()
          }
        }
      }
    }
  }
  
  console.log('para.TypeIndex', para.TypeIndex)
  if (!para.TypeIndex) {
    para.TypeIndex = '-1'
    console.log('para.TypeIndex2', para.TypeIndex)
  }
  
  // if(!para.OrderTime){
  //   para.OrderTime='ACTUALOPERATETIME DESC'
  // }

  if(alone.orderRule){
    if(alone.OrderTime){
      para.OrderTime=alone.OrderTime+' '+ alone.orderRule;
    }else{
      let orderVal = para.OrderTime.split(' ')
      if(orderVal.length==1){
        para.OrderTime=para.OrderTime+' '+alone.orderRule;
      }else{
        para.OrderTime=orderVal[0]+' '+alone.orderRule;
      }
    }
  }
  return para
}

function setQueryTitle(queryTitle, alone) {
  let AllServerCenterval = localStorage.getItem('AllServerCenter');
  if (AllServerCenterval) {
    let AllServerCenter = JSON.parse(AllServerCenterval);
    //待完成
    if (alone.serviceDesk == '1') {
      AllServerCenter = AllServerCenter.filter(item => item.ONLINE == true)
      if (AllServerCenter.length > 0) {
        let AllServerCenterName = AllServerCenter.map(function (item) {
          return item.NAME;
        }).join();
        queryTitle.forEach(item => {
          if (item.key == 'ServiceDeskName') {
            item.value += "(" + AllServerCenterName + ")"
          }
        })
      }

    } else if (alone.serviceDesk == '2') {
      if (AllServerCenter.length > 0) {
        let AllServerCenterName = AllServerCenter.map(function (item) {
          return item.NAME;
        }).join();
        console.log(AllServerCenterName);
        console.log(queryTitle);
        queryTitle.forEach(item => {
          if (item.key == 'ServiceDeskName') {
            item.value += "(" + AllServerCenterName + ")"
          }
        })
      }
    }
  }
  return queryTitle;
}
/**
 * 任务组查询条件通用方法调用：适用于任务精确查找
 * @param {*} para 任务搜索条件
 * @param {*} isType 0:文本框内容精确查找 1：模板直接查询 2.创建模板
 */
function searchTaskGroup(para, isType) {
  let alone = para.Alone
  alone.createtimeRange = timeDisposal(
    alone.createtimeRange,
    alone.createtimeRadio,
    alone.createtimeInput,
    alone.createTimeDynamic
  )
  if (alone.createtimeRange.length === 2) {
    para.CreateTime1 = alone.createtimeRange[0]
    para.CreateTime2 = alone.createtimeRange[1]
  }

  // console.log('执行人本人', alone.ExcuteMe);
  //时间处理结束
  //人员时本人
  if (alone.ExcuteMe && isType !== 2) {
    //执行人是本人
    para.ExcuteUserId = cookieUser.userId
  }
  if (alone.CreateMe && isType !== 2) {
    //创建人是本人
    para.CreateUserId = cookieUser.userId
  }
  return para
}
/**
 * 动态获取时间方法
 * @param {*} Range 时间区间
 * @param {*} Radio 选择类型 1.最近七天 2.最近一个月 3.最近动态
 * @param {*} Input Radio为3时候需要传输，需要最近多少小时，最近多少天，最近多少月
 * @param {*} Dynamic 时间类型 1小时 2天 3月
 */
function timeDisposal(Range, Radio, Input, Dynamic) {
  //获取最近时间方法
  let timeRange = Range
  if (Radio) {
    switch (Radio) {
      case 1:
        timeRange = timeJs.getRecentlyTime(7, 2)
        console.log('创建时间', timeRange)
        break
      case 2:
        timeRange = timeJs.getRecentlyTime(1, 4)
        break
      case 3:
        console.log('自定义', Input, Dynamic)
        timeRange = timeJs.getRecentlyTime(Input, Dynamic)
        break
      case 4:
        console.log('自定义', Input, Dynamic)
        timeRange = timeJs.getRecentlyTime2(Input, Dynamic)
        break
      case 5:
        timeRange = timeJs.getRecentlyTime2(7, 2)
        console.log('后时间', timeRange)
        break
      case 6:
        timeRange = timeJs.getRecentlyTime2(1, 4)
        console.log('后时间', timeRange)
        break
    }
  }
  return timeRange
  // audittimeRange: [], //审批时间
  // audittimeRadio: '', //审批时间选择
  // audittimeInput: '', //审批时间填写
  // auditTimeDynamic: '0', //审批时间（小时,天，周，月）
}
/**
 * 动态获取时间显示
 * @param {*} Range 时间区间
 * @param {*} Radio 选择类型 1.最近七天 2.最近一个月 3.最近动态
 * @param {*} Input Radio为3时候需要传输，需要最近多少小时，最近多少天，最近多少月
 * @param {*} Dynamic 时间类型 1小时 2天 4周 3月
 */
function timeTitle(Range, Radio, Input, Dynamic) {
  let timeTitle = ''
  switch (Radio) {
    case 1: //最近七天
      timeTitle = '最近七天'
      break
    case 2: //最近一个月
      timeTitle = '最近一个月'
      break
    case 3: //最近填写的
      let tiemType = '小时'
      switch (Dynamic) {
        case 1:
          tiemType = '小时'
          break
        case 2:
          tiemType = '天'
          break
        case 3:
          tiemType = '周'
          break
        case 4:
          tiemType = '月'
          break
      }
      timeTitle = '最近' + Input + tiemType
      break
    case 4: //后填写的
      let tiemType2 = '小时'
      switch (Dynamic) {
        case 1:
          tiemType2 = '小时'
          break
        case 2:
          tiemType2 = '天'
          break
        case 3:
          tiemType2 = '周'
          break
        case 4:
          tiemType2 = '月'
          break
      }
      timeTitle = '后' + Input + tiemType2
      break
    case 5:
      timeTitle = '后七天'
      break
    case 6:
      timeTitle = '后一个月'
      break
    default:
      if(Range){
        if (Range.length == 2) {
          timeTitle = Range[0] + '-' + Range[1]
        }
      }
      break
  }
  return timeTitle
}
/**
 * 任务查询条件显示到查询框需要的数据结构
 * @param {*} para 任务搜索条件
 */
function serachTaskDisplay(para) {
  let alone = para.Alone
  // para.forEach(function(column){})
  if (para.CreateTime1 && para.CreateTime2) {
    //创建时间
    para.Alone.createtimeRange = [para.CreateTime1, para.CreateTime2]
  }
  // para.Alone.createtimeRange=timeDisposal(para.Alone.createtimeRange,para.Alone.createtimeRadio,para.Alone.createtimeInput,para.Alone.createTimeDynamic);

  if (para.AcceptTime1 && para.AcceptTime2) {
    //接收时间
    para.Alone.receiveTimeRange = [para.AcceptTime1, para.AcceptTime2]
  }
  // para.Alone.receiveTimeRange=timeDisposal(para.Alone.receiveTimeRange,para.Alone.receiveTimeRadio,para.Alone.receiveTimeInput,para.Alone.receiveTimeDynamic);

  if (para.TransferTime1 && para.TransferTime2) {
    //流转时间
    para.Alone.circulationtimeRange = [para.TransferTime1, para.TransferTime2]
  }
  // para.Alone.circulationtimeRange=timeDisposal(para.Alone.circulationtimeRange,para.Alone.circulationtimeRadio,para.Alone.circulationtimeInput,para.Alone.circulationtimeDynamic);

  if (para.AuditTime1 && para.AuditTime2) {
    //审批时间
    para.Alone.audittimeRange = [para.AuditTime1, para.AuditTime2]
  }
  // para.Alone.audittimeRange=timeDisposal(para.Alone.audittimeRange,para.Alone.audittimeRadio,para.Alone.audittimeInput,para.Alone.auditTimeDynamic);

  if (para.CompleteTime1 && para.CompleteTime2) {
    //完成时间
    para.Alone.completetimeRange = [para.CompleteTime1, para.CompleteTime2]
  }
  // para.Alone.completetimeRange=timeDisposal(para.Alone.completetimeRange,para.Alone.completetimeRadio,para.Alone.completetimeInput,para.Alone.completeTimeDynamic);

  if (para.CloseTime1 && para.CloseTime2) {
    //完成时间
    para.Alone.closetimeRange = [para.CloseTime1, para.CloseTime2]
  }
  if (para.OutDateTime1 && para.OutDateTime2) {
    //完成时间
    para.Alone.overduetimeRange = [para.OutDateTime1, para.OutDateTime2]
  }
  // para.Alone.closetimeRange=timeDisposal(para.Alone.closetimeRange,para.Alone.closetimeRadio,para.Alone.closetimeInput,para.Alone.closeTimeDynamic);

  if (para.CreateUserIds) {
    //创建人
    let CreateUserIds = para.CreateUserIds.split(',')
    console.log('创建人',CreateUserIds)
    if (para.Alone.CreateMe) {
      //创建人是本人
      CreateUserIds.splice(CreateUserIds.findIndex(item => item === cookieUser.userId), 1)
    }
    para.Alone.CreateUserIds = CreateUserIds
  }
  if(para.AnswerUserIds){
    para.Alone.AnswerUserIds = para.AnswerUserIds.split(',')
  }
  if (para.TaskMemeberIds) {
    //干系人
    let TaskMemeberIds=para.TaskMemeberIds.split(',');
    if (para.Alone.TaskMemeberMe) {
      TaskMemeberIds.splice(TaskMemeberIds.findIndex(item => item === cookieUser.userId), 1)
    }
    para.Alone.TaskMemeberIds =TaskMemeberIds
  }
  // if (para.LinkManIds) { //联系人
  //   console.log(para.LinkManIds.split(','));
  //   para.Alone.LinkManIds = para.LinkManIds.split(',');
  // }
  if (para.ExcuteUserIds) {
    //执行人
    let ExcuteUserIds=para.ExcuteUserIds.split(',');
    if (para.Alone.ExcuteMe) {
      ExcuteUserIds.splice(ExcuteUserIds.findIndex(item => item === cookieUser.userId), 1)
    }
    para.Alone.ExcuteUserIds = ExcuteUserIds
  }

  if (para.ConvertUserIds) {
    //流转人
    let ConvertUserIds=para.ConvertUserIds.split(',');
    if (para.Alone.ConvertMe) {
      ConvertUserIds.splice(ConvertUserIds.findIndex(item => item === cookieUser.userId), 1)
    }
    para.Alone.ConvertUserIds = ConvertUserIds
  }

  if (para.Alone.TaskRightTypes) {
    //组织机构
    para.Alone.TaskRightIds = para.Alone.TaskRightTypes
  }
  if (para.DeviceId) {
    //设备
    para.Alone.DeviceIds = para.DeviceId.split(',')
  } else {
    para.Alone.DeviceIds = []
  }
  if (para.FaultType) {
    //故障类型
    para.Alone.FaultType = para.FaultType.split(',')
  } else {
    para.Alone.FaultType = []
  }
  if (!Array.prototype.isPrototypeOf(para.CreateSource) && para.CreateSource) {
    //报修来源
    para.CreateSource = para.CreateSource.split(',')
  } else {
    para.CreateSource = []
  }
  if (!Array.prototype.isPrototypeOf(para.TaskDegree) && para.TaskDegree) {
    //任务等级
    para.TaskDegree = para.TaskDegree.split(',')
  } else {
    para.TaskDegree = []
  }
  if (!Array.prototype.isPrototypeOf(para.TaskType) && para.TaskType) {
    //任务类型
    para.TaskType = para.TaskType.split(',')
  } else {
    para.TaskType = []
  }
  if (para.TypeIndex === '-1') {
    para.TypeIndex = ''
  }
  // if(para.OrderTime){
  //   let orderVal = para.OrderTime.split(' ');
  //   if(orderVal.length==2){
  //     para.Alone.OrderTime=orderVal[0];
  //     para.Alone.orderRule=orderVal[1];
  //   }
  // }
  
  return para
}

function queryTaskTitle(para) {
  let queryTitle = []
  let searchTitle = [
    {
      title: '任务编号',
      key: 'TaskInstance',
      value: '',
      type: 1
    },
    {
      title: '任务名称',
      key: 'TaskName',
      value: ''
    },
    {
      title: '创建时间',
      key: 'CreateTime',
      value: ''
    },
    {
      title: '创建人',
      key: 'CreateUser',
      value: ''
    },
    {
      title: '执行人',
      key: 'ExcuteUser',
      value: ''
    },
    {
      title: '任务类型',
      key: 'TaskType',
      value: ''
    },
    {
      title: '执行状态',
      key: 'state',
      value: ''
    },
    {
      title: '创建来源',
      key: 'CreateClass',
      value: ''
    },
    {
      title: '报修来源',
      key: 'CreateSource',
      value: ''
    },
    {
      title: '角色分类',
      key: 'TypeIndex',
      value: ''
    },
    {
      title: '服务台',
      key: 'ServerCenterIds',
      value: ''
    },
    {
      title: '机构组织',
      key: 'TaskRightId',
      value: ''
    },
    {
      title: '任务等级',
      key: 'TaskDegree',
      value: ''
    },
    {
      title: '接收时间',
      key: 'AcceptTime',
      value: ''
    },
    {
      title: '完成时间',
      key: 'CompleteTime',
      value: ''
    },
    {
      title: '流转时间',
      key: 'TransferTime',
      value: ''
    },
    {
      title: '关闭时间',
      key: 'CloseTime',
      value: ''
    },
    {
      title: '联系人',
      key: 'LinkManId',
      value: ''
    },
    {
      title: '干系人',
      key: 'TaskMemeberId',
      value: ''
    },
    {
      title: '故障设备',
      key: 'DeviceId',
      value: ''
    },
    {
      title: '故障类型',
      key: 'FaultType',
      value: ''
    },
    {
      title: '故障地址',
      key: 'Location',
      value: ''
    },
    {
      title: '联系人',
      key: 'LinkManIds',
      value: ''
    },
    {
      title: '干系人',
      key: 'TaskMemeberIds',
      value: ''
    },
    {
      title: '创建人',
      key: 'CreateUserIds',
      value: ''
    },
    {
      title: '执行人',
      key: 'ExcuteUserIds',
      value: ''
    }
    // RoleType:'',//组织机构相关人人员（逗号分隔 1.创建人 2. 执行人 3.干系人 4.联系人 ）
  ]
  // searchTitle.forEach(element=>{
  // 	console.log(element.title)
  // });
  for (var key in para) {
    console.log(key) //获取key值
    console.log(para[key]) //获取对应的value值
  }
  // if(para.)
}
export default {
  searchTask,
  searchTaskGroup,
  serachTaskDisplay,
  timeDisposal,
  queryTaskTitle,
  timeTitle,
  setQueryTitle
}
